import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogRef} from "@angular/material/dialog";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatError, MatFormField, MatLabel} from "@angular/material/form-field";
import {MatIcon} from "@angular/material/icon";
import {MatInput} from "@angular/material/input";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect, MatSelectTrigger} from "@angular/material/select";
import {MatSlideToggle} from "@angular/material/slide-toggle";
import {DistributionsRepository} from "../../../shared/repositories/distributions.repository";
import {DecimalsOnlyDirective} from "../../../shared/directives/decimals-only.directive";

@Component({
  selector: 'app-distribution-dialog',
  standalone: true,
  imports: [
    FormsModule,
    MatButton,
    MatDialogActions,
    MatError,
    MatFormField,
    MatIcon,
    MatIconButton,
    MatInput,
    MatLabel,
    MatOption,
    MatSelect,
    MatSelectTrigger,
    MatSlideToggle,
    ReactiveFormsModule,
    DecimalsOnlyDirective
  ],
  templateUrl: './distribution-dialog.component.html',
  styleUrl: './distribution-dialog.component.scss'
})
export class DistributionDialogComponent implements OnInit {

  form: FormGroup;
  isFormSubmitted: boolean = false;
  selectedPackages: string[];
  allPackages: string[] = [];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<DistributionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private distributionsRepository: DistributionsRepository
  ) {}

  ngOnInit() {
    this.mapPackages();
    this.form = this.fb.group({
      name: [this.data.type === 'create' ? '' : this.data.distribution.name, [Validators.required]],
      altName: [this.data.type === 'create' ? '' : this.data.distribution.altName, [Validators.required]],
      color: [this.data.type === 'create' ? '' : this.data.distribution.color, [Validators.required]],
      logo: [this.data.type === 'create' ? '' : this.data.distribution.logo, [Validators.required]],
      background: [this.data.type === 'create' ? '' : this.data.distribution.background],
      oneTimeEnrollmentFee: [this.data.type === 'create' ? null : this.data.distribution.oneTimeEnrollmentFee],
      packages: [this.data.type === 'create' ? [] : this.selectedPackages],
    });
  }

  mapPackages() {
    this.data.packages.forEach((p) => {
      if (!this.allPackages.includes(p.altName)) {
        this.allPackages.push(p.altName);
      }
    });
    if (this.data.type === 'edit') {
      const selectedPackages = this.data.distribution.packages.map((i) => {
        return this.data.packages.find((p) => i.id === p.id).altName;
      });
      this.selectedPackages = [... new Set(selectedPackages)] as string[];
    }
  }

  onCanceled(): void {
    this.dialogRef.close();
  }

  submit() {
    this.form.updateValueAndValidity();
    this.form.markAllAsTouched();
    this.isFormSubmitted = true;
    const packagesIds = this.mapPackagesForSubmit();
    if (this.form.valid) {
      const requestData = this.data.type === 'edit' ?
        {
          ...this.form.value,
          packages: packagesIds,
          id: this.data.distribution.id,
          oneTimeEnrollmentFee: this.form.value.oneTimeEnrollmentFee ? +this.form.value.oneTimeEnrollmentFee : null,
        } :
        {
          ...this.form.value,
          packages: packagesIds,
          oneTimeEnrollmentFee: this.form.value.oneTimeEnrollmentFee ? +this.form.value.oneTimeEnrollmentFee : null,
        };
      this.distributionsRepository.createEditDistribution(requestData).subscribe({
        next: () => {
          this.dialogRef.close(true);
        },
        error: (err) => {
          console.error(err);
        }
      });
    }
  }

  mapPackagesForSubmit(): {id: string}[] {
    const packagesIds:{id: string}[]  = [];
    this.data.packages.forEach((i) => {
      this.form.value.packages.forEach((p) => {
        if (i.altName === p) {
          packagesIds.push({id: i.id});
        }
      });
    });
    return packagesIds;
  }
}
